import { render, staticRenderFns } from "./placeAnotherOrder.vue?vue&type=template&id=012f7cf8"
import script from "./placeAnotherOrder.vue?vue&type=script&lang=js"
export * from "./placeAnotherOrder.vue?vue&type=script&lang=js"
import style0 from "./placeAnotherOrder.vue?vue&type=style&index=0&id=012f7cf8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports